export default "__VITE_ASSET__Bcs7sFU4__"